module.exports = __webpack_public_path__ + "sm.07801da87b2073824e1e.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/sm.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/sm.svg
// module chunks = styles